import { useState } from 'react';
import { useAnalytics } from '@msrceng/analytics';
/**
 * This hook creates the state for whether the column selector's
 * panel is open or closed.
 */
export const useColumnSelectorPanelState = () => {
    const { appInsights } = useAnalytics();
    const [isOpen, setOpen] = useState(false);
    const toggle = () => {
        setOpen(o => {
            if (!o) {
                appInsights === null || appInsights === void 0 ? void 0 : appInsights.trackEvent({ name: 'Column Selector Opened' });
            }
            return !o;
        });
    };
    return { isOpen, toggle, setOpen };
};
